import { createFileRoute } from "@tanstack/react-router";
import { FSRSSecondaryNav } from "../../../components/analytics/layout/FSRSSecondaryNav";
import { MainSidebar } from "../../../components/sidebars/MainSidebar";
import { SystemSettingsPage } from "../../../pages/fsrs/SystemSettingsPage";

function FSRSSystemSettingsWithSidebar() {
  return (
    <div className="flex h-screen">
      <MainSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <FSRSSecondaryNav />
        <div className="flex-1 overflow-auto p-6">
          <SystemSettingsPage />
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/admin/fsrs/system")({
  component: FSRSSystemSettingsWithSidebar,
});
